import {useQuery} from '@tanstack/react-query'
import {api} from '@/lib/api'
import type {Page} from '@/lib/page'
import type {SortDir} from '@/hooks/common/use-table-state'

/** `extra` viaja como query params y entra en la clave de caché. */
export type PagedListParams = {
  page: number
  search: string
  // Opcionales: un endpoint que no los honra responde 200 con otro orden, sin señal.
  sortBy?: string
  sortDir?: SortDir
  extra?: Record<string, string | number | undefined>
}

/** Params de `PageParams` del backend. `R` admite páginas con datos de la misma lectura (U19); `refetchInterval`
 * sigue jobs que en prod van por Cloud Tasks y en dev son en línea. */
export function usePagedList<T, R extends Page<T> = Page<T>>(
  queryKey: unknown[],
  url: string | undefined,
  params: PagedListParams,
  pageSize: number,
  refetchInterval?: (query: {state: {data?: R}}) => number | false
) {
  return useQuery({
    refetchInterval,
    queryKey: [...queryKey, params, pageSize],
    queryFn: async () =>
      (
        await api.get<R>(url!, {
          params: {
            page: params.page,
            page_size: pageSize,
            search: params.search || undefined,
            sort_by: params.sortBy,
            sort_dir: params.sortDir,
            ...params.extra,
          },
        })
      ).data,
    enabled: !!url,
    placeholderData: (previous) => previous,
  })
}
